import {CheckPaymentResponseBody} from '@/types/payments';
import keycloakAxios from '@/services/axios';

export const checkPaymentStatus = async (eventId: string) => {
  const response = await keycloakAxios.get<CheckPaymentResponseBody>(
    `payments/check-payment/${eventId}`
  );

  if (response.status >= 300) {
    throw new Error(
      `Error checking payment status: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
